import { validate } from 'email-validator';

export const isValidEmail = (email: string): boolean => {
  return validate(email);
};
